/**
 * 案例详情. 开始练习 opens the coach with this case; the coach asks for the
 * level, then the trainee starts from the summary.
 */

import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { PrimaryButton } from '@euler/app/flows/ai-suite/components/PrimaryButton';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { CoachingNavParams } from '@euler/app/flows/coaching';
import { EmptyView } from '@euler/components/EmptyView';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { ActivityIndicator, View } from 'react-native';
import { openCoachingCase } from '../../functions/openCoachingSetup';
import { useCaseDetail } from '../../functions/useCaseDetail';
import { CaseDetailView } from './CaseDetailView';

export const CoachingCaseScreen = wrapNavigatorScreen(
  ({ caseId }: { caseId: string }) => {
    const { rpx } = useResponsiveContext();
    const appNavigation = useAppNavigation();
    const navigation = useNavigation<StackNavigationProp<CoachingNavParams>>();
    const { state, reload } = useCaseDetail(caseId);
    if (state.kind === 'loading')
      return (
        <ActivityIndicator
          color={aiColors.primary}
          style={{ marginTop: rpx(48) }}
        />
      );
    if (state.kind === 'failed')
      return <EmptyView message="案例暂时没加载出来" onRetry={reload} />;
    return (
      <View style={{ flex: 1 }}>
        <View style={{ flex: 1 }}>
          <CaseDetailView
            detail={state.detail}
            onOpenRelated={card => navigation.push('case', { caseId: card.id })}
            onOpenAllRelated={() => navigation.push('related', { caseId })}
            onOpenTag={tag =>
              navigation.push('catalog', { tag: tag.slug, tagName: tag.name })
            }
          />
        </View>
        <View
          style={{
            padding: rpx(16),
            borderTopWidth: 1,
            borderTopColor: aiColors.border,
            backgroundColor: aiColors.card,
          }}
        >
          <View
            style={{ width: '100%', maxWidth: rpx(736), alignSelf: 'center' }}
          >
            <PrimaryButton
              title="开始练习"
              onPress={() =>
                openCoachingCase(appNavigation, {
                  caseId: state.detail.id,
                  title: state.detail.title,
                })
              }
            />
          </View>
        </View>
      </View>
    );
  },
  { title: '案例详情' },
);
